import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import { openWhatsApp, openTelegram } from '../../utils/contactHelpers';

const RelationshipSearchWebinarPage = () => {
  const handleTelegramRegistration = () => {
    openTelegram();
    // Note: Telegram bot should be configured to handle webinar registration messages
  };

  const handleWhatsAppRegistration = () => {
    openWhatsApp('Здравствуйте! Запишите меня, пожалуйста, на вебинар по поиску партнера');
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-foreground text-background py-4 sticky top-0 z-50 shadow-md">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <Icon name="ArrowLeft" size={24} />
            <span className="text-sm font-medium">Назад на главную</span>
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Heart" size={20} color="white" />
            </div>
            <span className="font-bold">AI Dating</span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <div className="w-20 h-20 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="Search" size={40} color="white" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Вебинар: Поиск отношений
          </h1>
          <p className="text-xl text-foreground/70 max-w-3xl mx-auto">
            Современные методы знакомств: эффективность, стоимость и личная помощь от экспертов
          </p>
        </div>

        {/* Webinar Image */}
        <div className="mb-16">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_1d0cdaa29-1763299396604.png"
            alt="Психолог проводит консультацию по поиску отношений"
            className="w-full h-96 object-cover rounded-2xl shadow-xl" />

        </div>

        {/* Registration Buttons */}
        <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 mb-16">
          <h2 className="text-2xl font-bold text-foreground text-center mb-6">
            Записаться на вебинар
          </h2>
          <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <button
              onClick={handleTelegramRegistration}
              className="flex items-center justify-center gap-3 bg-blue-500 hover:bg-blue-600 text-white py-4 px-6 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg">

              <Icon name="Send" size={24} />
              <span>Записаться через Telegram</span>
            </button>
            <button
              onClick={handleWhatsAppRegistration}
              className="flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white py-4 px-6 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg">

              <Icon name="MessageCircle" size={24} />
              <span>Записаться через WhatsApp</span>
            </button>
          </div>
        </div>

        {/* Specialist Section */}
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-3xl font-bold text-foreground mb-6">
              Ведущие специалисты
            </h2>
            <div className="space-y-4 text-foreground/80">
              <p>
                Вебинар проводят опытные психологи и социологи с многолетним стажем работы в области отношений и знакомств.
              </p>
              <div className="bg-white p-6 rounded-xl shadow-md">
                <h3 className="font-semibold text-foreground mb-3">Квалификация специалистов:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={20} className="text-blue-500 mt-0.5" />
                    <span>Высшее психологическое образование</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={20} className="text-blue-500 mt-0.5" />
                    <span>Специализация в психологии отношений</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={20} className="text-blue-500 mt-0.5" />
                    <span>Опыт работы более 10 лет</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={20} className="text-blue-500 mt-0.5" />
                    <span>Исследования современных методов знакомств</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <img
              src="https://img.rocket.new/generatedImages/rocket_gen_img_1bf0633c1-1763295638320.png"
              alt="Психолог-специалист по отношениям"
              className="w-full h-96 object-cover rounded-2xl shadow-xl" />
          </div>
        </div>

        {/* Webinar Program */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-foreground text-center mb-12">
            Программа вебинара
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <Icon name="TrendingUp" size={24} color="white" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">
                Современные методы знакомств
              </h3>
              <p className="text-foreground/70">
                Обзор всех доступных способов поиска партнёра: от традиционных до инновационных AI-технологий. Разбор преимуществ и недостатков каждого метода.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <Icon name="DollarSign" size={24} color="white" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">
                Сравнение стоимости и эффективности
              </h3>
              <p className="text-foreground/70">
                Детальный анализ затрат времени и денег на разные методы поиска. Статистика успешности различных подходов на основе реальных данных.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <Icon name="MessageSquare" size={24} color="white" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">
                Ответы на личные вопросы
              </h3>
              <p className="text-foreground/70">
                Интерактивная сессия вопросов и ответов. Специалисты помогут разобраться в вашей конкретной ситуации и дадут персональные рекомендации.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <Icon name="Users" size={24} color="white" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">
                Психологические барьеры
              </h3>
              <p className="text-foreground/70">
                Работа с внутренними блоками и страхами, мешающими найти партнёра. Практические техники повышения уверенности в себе.
              </p>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-12 mb-16">
          <h2 className="text-3xl font-bold text-foreground text-center mb-8">
            Что вы получите
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="BookOpen" size={28} color="white" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">Знания</h3>
              <p className="text-foreground/70 text-sm">
                Полное понимание современного рынка знакомств
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Target" size={28} color="white" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">Стратегию</h3>
              <p className="text-foreground/70 text-sm">
                Персональный план действий для поиска партнёра
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Heart" size={28} color="white" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">Уверенность</h3>
              <p className="text-foreground/70 text-sm">
                Психологическую поддержку и мотивацию
              </p>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl p-12 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">
            Начните свой путь к счастливым отношениям
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Запишитесь на вебинар прямо сейчас
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleTelegramRegistration}
              className="flex items-center justify-center gap-3 bg-white text-blue-600 hover:bg-blue-50 py-4 px-8 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg">

              <Icon name="Send" size={24} />
              <span>Telegram</span>
            </button>
            <button
              onClick={handleWhatsAppRegistration}
              className="flex items-center justify-center gap-3 bg-white text-green-600 hover:bg-green-50 py-4 px-8 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg">

              <Icon name="MessageCircle" size={24} />
              <span>WhatsApp</span>
            </button>
          </div>
        </div>
      </main>

      {/* Back to Top Button */}
      <div className="fixed bottom-8 right-8">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="bg-blue-500 text-white p-4 rounded-full shadow-lg hover:bg-blue-600 transition-all hover:scale-110"
          aria-label="Вернуться наверх">

          <Icon name="ArrowUp" size={24} />
        </button>
      </div>
    </div>);

};

export default RelationshipSearchWebinarPage;